import {
    AnimationBaseController,
    Environment,
    EnvironmentTypeEnum,
    GameRandom,
} from "../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../Models/GameModel";
import { GameLogic } from "../../Logic/GameLogic";
import { AnimationContents } from "../AnimationContents";

export interface IContinueLabelControllerOptions {
    onComplete: () => void
}

export class ContinueLabelController extends AnimationBaseController {

    $model: GameModel;
    private _count = 3;

    public constructor(@Inject private _options: IContinueLabelControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("ContinueLabelController");
        console.log('ContinueLabelController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: "continue_label",
            childControllers: {

            },
            modelWatch: {
                "pause": (pause: boolean) => {
                    if (pause) {
                        this.stop();
                    } else {
                        this.play();
                    }
                }
            }
        };
    }

    protected onInitialize(): void {
        this.y = -650;
        this.loop = true;
        this.gotoAndStop(0);
    }

    play() {
        this._count = 3;
        this.setTextByQuery('continue_label_text.text', this._count.toString());
        this.gotoAndPlay(0);
    }

    protected onResize(width: number, height: number, scale: number): void {
        width = width / scale;
        this.x = (0.5 * width - this.$model.cameraPos.x) / this.$model.cameraZoom;
    }

    protected onAnimationEvent(name: string, ...args) {
        if (name === 'loop') {
            this.setTextByQuery('continue_label_text.text', (--this._count).toString());
            if (!this._count) {
                this.stop();
                this.setTextByQuery('continue_label_text.text', '');
                this._options.onComplete();
            }
        }
    }
}

